<template>
  <Modal
    :cancelText="cancelText"
    :okText="okText"
    sm
    :lg="lg"
    :full="full"
    :hideHeader="hideHeader"
    hideFooter
    :persistent="persistent"
    :title="$t('common.updateTitle')"
    @closing="$emit('closing')"
    @ok="$emit('ok')"
    @destroyed="$emit('destroyed')"
    @cancel="$emit('cancel')"
    @close="$emit('close')"
    :value="value"
    @input="$emit('input', $event)"
  >
    <div class="u-text-align-center">
      <img src="@/assets/images/Confirm.svg" width="120" alt="confirm" />
    </div>
    <span>
      {{ description || $t("common.updateDescription") }}
    </span>
    <div class="u-display-flex u-margin-top u-justify-content-flex-end">
      <Button block @click="$emit('input', false)">
        {{ $t("common.cancel") }}
      </Button>
      <Button
        block
        class="u-margin-left-xsmall"
        variant="warning"
        @click="(e, l) => $emit('ok', l)"
      >
        {{ $t("common.update") }}
      </Button>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/Base/Modal.vue";
import Button from "@/components/Base/Button.vue";
export default {
  components: {
    Button,
    Modal,
  },
  props: {
    value: {
      default: false,
    },
    description: {
      default: "",
    },
    title: {
      default: "",
    },
    cancelText: {
      type: String,
      default: function () {
        return this.$t("cancel");
      },
    },
    sm: {
      default: false,
      type: Boolean,
    },
    lg: {
      default: false,
      type: Boolean,
    },
    full: {
      default: false,
      type: Boolean,
    },
    hideHeader: {
      default: false,
      type: Boolean,
    },
    hideFooter: {
      default: false,
      type: Boolean,
    },
    persistent: {
      default: false,
      type: Boolean,
    },
    okText: {
      type: String,
      default: function () {
        return this.$t("save");
      },
    },
  },
};
</script>

<style></style>
